import { ELIGIBILITY_TYPE } from '../const/eligibilityType';
const eligibleForEcheck = (paymentMethod) => paymentMethod.subEligibilityType === 'E_CHECK';
const eligibleForDebit = (paymentMethod) => paymentMethod.subEligibilityType === 'PINLESS_DEBIT_CARD';
const eligibleForCredit = (paymentMethod) => paymentMethod.subEligibilityType === 'CREDIT_CARD';
export const getPaymentMethodsFromPaymentEnterpriseEligibility = (productType, paymentEnterpriseEligibilityQueryResult, featureFlags) => {
    if (!paymentEnterpriseEligibilityQueryResult[ELIGIBILITY_TYPE.ALLOWED_PAYMENT_METHODS]) {
        throw new Error(`no allowed payment types for product type ${productType}`);
    }
    const { ALLOWED_PAYMENT_METHODS: allowedPaymentMethods } = paymentEnterpriseEligibilityQueryResult;
    const paymentMethods = [];
    const [echeckPaymentMethod] = allowedPaymentMethods.filter(eligibleForEcheck);
    if (echeckPaymentMethod) {
        const criteriaValues = echeckPaymentMethod.criteria
            .filter(({ value }) => {
            if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.isSavingCheckingEnabled) {
                return value === 'CHECKING' || value === 'SAVINGS';
            }
            return value === 'CHECKING';
        })
            .map(({ value }) => value);
        paymentMethods.push(...criteriaValues);
    }
    if (allowedPaymentMethods.some(eligibleForDebit)) {
        paymentMethods.push('PINLESS_DEBIT_CARD');
    }
    if (allowedPaymentMethods.some(eligibleForCredit)) {
        paymentMethods.push('CREDIT_CARD');
    }
    return paymentMethods;
};
export const getDefaultPaymentMethodFromPaymentEnterpriseEligibility = (productType, paymentEnterpriseEligibilityQueryResult) => {
    const [defaultPaymentMethod] = getPaymentMethodsFromPaymentEnterpriseEligibility(productType, paymentEnterpriseEligibilityQueryResult);
    return defaultPaymentMethod;
};
